export default "__VITE_ASSET__da4e954a__"